<script setup lang="ts">
useSetup()
</script>

<template>
  <div>
    <NuxtLoadingIndicator color="repeating-linear-gradient(to right,var(--c-primary) 0%,var(--c-primary-active) 100%)" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <GToaster />
  </div>
</template>
